import { useEffect } from 'react';
import styles from './Network.module.css';
import { useNetworkMutations } from '../../hooks/network/useNetworkMutations';
import { useNetworkData } from '../../hooks/network/useNetworkData';
import ConnectionsList from './ConnectionsList';

/**
 * NetworkPanel
 * Props:
 * - mode: 'hub-spoke' | 'many-to-many'
 * - role: 'hub' | 'spoke' (used only when mode === 'hub-spoke')
 */
function NetworkPanel({ mode = 'hub-spoke', role = 'spoke' }) {
    const mutations = useNetworkMutations();
    const {
        local,
        connections,
        connectedList
    } = useNetworkData();

    // Clear approve error state when conflicts are resolved (conflicting connections are deleted)
    useEffect(() => {
        const approveError = mutations.approveConnection.error;
        if (!approveError) return;
        
        const errorResponse = approveError?.response?.data || approveError?.data;
        const errorApiUrl = errorResponse?.duplicateApiUrl;
        
        // If there's an error for a duplicate API URL, check if that conflict still exists
        if (errorApiUrl) {
            const conflictingConnection = connectedList.find(conn => conn.url === errorApiUrl);
            // If no conflict exists anymore, clear the error
            if (!conflictingConnection) {
                mutations.approveConnection.reset();
            }
        }
    }, [connectedList, mutations.approveConnection]);


    if (!local) {
        return (<><h3>You must save configuration before connecting to the network.</h3></>);
    }

    return (
        <>
            <ConnectionsList
                connections={connections}
                mode={mode}
                role={role}
                connectedList={connectedList}
                mutations={mutations}
                onRefresh={mutations.refreshConnections.mutate}
            />
        </>
    );
}

export default NetworkPanel;

